<template>
	<div>
		<breadcrumb :items="[{ text: 'Redes', to: '/redes' }, { text: organization.name, active: true }]" />
		<p><small>{{organization.description}}</small></p>
		<div class="tree">
			<div class="item-info">
				<strong>Fornecedores:</strong>
			</div>
			<ul>
				<li v-for="supplier in organization.suppliers" :key="supplier._id" :class="{ active: tree['supplier'] == supplier._id}">
					<div v-if="tree['supplier'] !== supplier._id">
						<a @click="toggleTree('supplier', supplier._id)">
							<i class="fa fa-plus-square" />
							{{supplier.name}}
						</a>
					</div>
					<div v-else>
						<a @click="toggleTree('supplier', supplier._id)">
							<i class="fa fa-minus-square" />
							{{supplier.name}}
							<router-link :to="'/editar-fornecedor/'+ supplier._id" class="btn btn-primary col-sm">
								Editar
							</router-link>
						</a>
						<div class="item-info">
							<strong>Produtos:</strong>
						</div>
						<ul>
							<li v-for="product in supplier.products" :key="product._id" :class="{ active: tree['product'] == product._id}">
								<div v-if="tree['product'] !== product._id">
									<a @click="toggleTree('product', product._id)">
										<i class="fa fa-plus-square" />
										{{product.name}}
									</a>
								</div>
								<div v-else>
									<a @click="toggleTree('product', product._id)">
										<i class="fa fa-minus-square" />
										{{product.name}}
										<router-link :to="'/editar-produto/'+ product._id" class="btn btn-primary col-sm">
											Editar
										</router-link>
									</a>
									<div class="item-info">
										<strong>Variações do produto:</strong>
									</div>
									<ul>
										<li v-for="product_variation in product.product_variations" :key="product_variation._id" :class="{ active: tree['product_variation'] == product_variation._id}">
											<div v-if="tree['product_variation'] !== product_variation._id">
												<a @click="toggleTree('product_variation', product_variation._id)">
													<i class="fa fa-plus-square" />
													{{product_variation.name}}
												</a>
											</div>
											<div v-else>
												<a @click="toggleTree('product_variation', product_variation._id)">
													<i class="fa fa-minus-square" />
													{{product_variation.name}}
													<router-link :to="'/editar-variacao-de-produto/'+ product_variation._id + '?product=' + product._id" class="btn btn-primary col-sm">
														Editar
													</router-link>
												</a>
												<div v-if="product_variation.offers.length > 0">
													<div class="item-info">
														<strong>Ofertas:</strong>
													</div>
													<ul>
														<li v-for="offer in product_variation.offers" :key="offer._id" :class="{ active: tree['offer'] == offer._id}">
															<div>
																<a @click="toggleTree('offer', offer._id)">
																	{{product_variation.name}} - {{offer.final_price | moeda}} - {{offer.qtd - offer.qtd_ordered}} disponíveis
																	<br>
																	<router-link :to="'/editar-oferta/'+ offer._id" class="btn btn-primary col-sm">
																		Editar
																	</router-link>
																	<router-link :to="'/oferta/'+ offer._id" class="btn btn-primary col-sm">
																		Ver na loja
																	</router-link>
																</a>
															</div>
														</li>
													</ul>
												</div>
												<div v-else>
													<div class="item-info">
														<strong>Sem ofertas cadastradas</strong>
													</div>
												</div>
											</div>
										</li>
									</ul>
								</div>
							</li>
						</ul>
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import axios from 'axios'

export default {

  name: 'OrganizationForm',
  data() {
    return {
      tree: {
				supplier: null,
				product: null,
				product_variation: null,
				offer: null
			},
      organization: null,
    }
  },
  created() {
		this.isLoading = true
		axios.get('organizations/' + this.$route.params.id + '/full', {
			params: {
				populate: 'suppliers'
			}
		}).then(response => {
			this.organization = response.data
			this.isLoading = false
		}).catch(this.showError);
  },
  methods: {
    toggleTree(level, item) {
      if (this.tree[level] === item) {
				this.tree[level] = null
			} else {
				this.tree[level] = item
			}
    }
  }
};
</script>
